//==============================
// Header
//==============================


var header = $('.header');
var button = $('.header-nav-button');
var nav = $('.header-nav');

// button
button.click(function() {
  header.toggleClass('open');
  button.toggleClass('open');
  nav.toggleClass('open');
});

// scroll
function headerNotTop() {
  header.addClass('scroll');
}
function headerAtTop() {
  header.removeClass('scroll');
}
function headerScroll() {
  var scrollPos = $(window).scrollTop();
  if (scrollPos<=1) {
    headerAtTop();
  }
  else {
    headerNotTop();
  }
}

headerScroll();

$(window).scroll(function() {
  headerScroll();
});

// hide header on scroll
// http://www.jquerybyexample.net/2013/07/jquery-detect-scroll-position-up-down.html
var scrollPos = 0;
$(window).scroll(function () {
  var currentScrollPos = $(this).scrollTop();
  if (currentScrollPos > scrollPos && currentScrollPos > 1 && header.is(':hover') == false && !header.hasClass('open')) {
    header.addClass('hidden');
  } else {
    header.removeClass('hidden');
  }
  scrollPos = currentScrollPos;
});


// Sub nav
$('.menu-item-has-children > a').click(function() {
  var thisItem = $(this);
  var thisSubMenu = thisItem.next('.sub-menu');
  thisSubMenu.addClass('active');
  $('#menu-header').addClass('display-sub-nav');
  $('.header-nav-back').addClass('active');
  return false;
});

$('.header-nav-back').click(function() {
  $('#menu-header').removeClass('display-sub-nav');
  $('.header-nav-back').removeClass('active');
  $('.sub-menu').removeClass('active');
});

$('.menu-item-has-children a').blur(function() {
  $('.sub-menu').removeClass('focus');
});

$('.menu-item-has-children > a').focus(function() {
  var thisItem = $(this);
  thisItem.next('.sub-menu').addClass('focus');
});


$('.sub-menu a').focus(function() {
  console.log('derp');
  var thisItem = $(this);
  thisItem.parent().parent().addClass('focus');
});




